module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 28
// module chunks = 0